import React from 'react'
import ReactDOM from 'react-dom/client'

import { assert } from '../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../domain'

import { createUsecases, initialState } from '../../application'

import { App, AppWrapper, cybusTheme } from '../react'
import customizerConfigPromise from './config'
import { resolveInjections } from './injections'

void customizerConfigPromise.then(({ customizedConfig, errors }) => {
    const { services, state, internationalization, missingPermissionsListener } = resolveInjections(initialState, customizedConfig)
    const usecases = createUsecases(services)

    usecases.debugApplicationUsecase.handleConfigurationErrors(errors)

    /** If there are authentication issues, handle the problem */
    // eslint-disable-next-line no-void
    missingPermissionsListener.on(() => void usecases.missingPermissionsUsecase.updateObsolescence())

    const root = document.getElementById('root')
    assert(root, new ConnectwareError(ConnectwareErrorType.UNEXPECTED, 'Failed to mount React app - root element was not found.'))

    ReactDOM.createRoot(root).render(
        <AppWrapper usecases={usecases} manager={state} internationalization={internationalization} theme={cybusTheme}>
            <App />
        </AppWrapper>
    )
})
